import { render } from "./ProjectDocs.vue?vue&type=template&id=977f9114&scoped=true"
import script from "./ProjectDocs.vue?vue&type=script&lang=js"
export * from "./ProjectDocs.vue?vue&type=script&lang=js"

import "./ProjectDocs.vue?vue&type=style&index=0&id=977f9114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977f9114"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTr,QTh,QIcon});
